import * as Yup from "yup";

export const BrandSchema = Yup.object({

    brand: Yup.string().required("Enter Brand Name"),
    status: Yup.string().required("Select Status"),
});